export const breakpoints = {
  small: '400px',
  medium: '800px',
};
